export * from './UserVotes';

import UserVotes from './UserVotes';
export default UserVotes;
